module.exports = __webpack_public_path__ + "img/xqgl1.f02a5eeb.png";